<template>
<div>
	<TopAppBarDrawer></TopAppBarDrawer>
	<main class="main-wrapper flex-grow-1 ">
	<div class="d-flex align-items-center bg-white">
		<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
			{{$t('1746')}}
		</div>
	</div>
	<div class="divider"></div>
	<div class="container container--narrow pdt-50 ">
		<div class="t-headline10 font-b mgb-8">{{$t('1760')}}</div>
		<div class="t-body1 t-color-bodyGrayA font-r">{{$t('1761')}}</div>
		<div class="mgt-40 ">
			<div class="mdc-select mdc-select--outlined w-full mdc--select__custom" :class="selectedCountry?'hasActiveVal':''" id="selectDuty">
				<i class="mdc-select__dropdown-icon select-icon-custom"></i>
				<select class="mdc-select__native-control mdc-select__anchor h-46 mdc-select-control-custom" v-model="selectedCountry">
					<option v-for="country in countryList" :key="country.id" :value="country">
							{{country.code}}{{country.number}}
					</option>
				</select>
				<div class="mdc-notched-outline">
					<div class="mdc-notched-outline__leading"></div>
					<div class="mdc-notched-outline__notch">
									<!-- <label class="mdc-floating-label"></label> -->
					</div>
					<div class="mdc-notched-outline__trailing"></div>
				</div>
			</div>
		</div>
		<div class="mgt-36 mgb-28">
			<label
				class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full h-46 "
				data-mdc-auto-init="MDCTextField" 
				:class="submitState && phoneInvalidCheck ? 'mdc-text-field--invalid invalid-icon-data' : 'valid-icon-data textFieldVal'"
					id="emailEl"
					>
				<div class="mdc-notched-outline">
					<div class="mdc-notched-outline__leading" :style="submitState && phoneInvalidCheck ? 'border-color:var(--Textfeilderror)!important;':''"></div>
					<div class="mdc-notched-outline__notch" :style="submitState && phoneInvalidCheck ? 'border-color:var(--Textfeilderror)!important;':''">
					<label for="tf-outlined" class="mdc-floating-label">
									{{$t('1762')}}
									<!-- 이메일 -->
					</label>
					</div>
					<div class="mdc-notched-outline__trailing"  :style="submitState && phoneInvalidCheck ? 'border-color:var(--Textfeilderror)!important;':''"></div>
				</div>
				<input class="mdc-text-field__input" type="text"
						v-model="phoneNo"
						v-validate="'required|min:2|max:50'"
						ref="phoneNo"
						id="phoneNo"
						name="phoneNo"
						pattern="[0-9]"
						@keypress="isNumber($event)"
						maxlength="50"
				/>
				<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" 
					role="button">{{validIcon}}</i>
			</label>
			<div class="mdc-text-field-helper-line">
						<div class="t-helper t-color-mainBtn mgl-7 mgr-7 pdt-2 min-h-23">
										<span v-show="submitState && phoneInvalidCheck">
												{{$t('1925')}}
										</span>
						</div>
			</div>
		</div>
		<div class="mgt-50 mgb-50 ">
			<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" @click="next()" @keypress="next()" tabindex="0">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{$t('1763')}}</span>
			</button>
			<button class="mdc-button bg-white t-color-secondaryBtnText b-radius4" @click="cancel()" @keypress="cancel()" tabindex="0">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{$t('1764')}}</span>
			</button>
		</div>
	</div>
	</main>
</div>
</template>

<script>
/**
 * 회원가입 - 직무 직책 컴포넌트(sign up - duty & responsibility component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCSelect} from '@material/select';
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import i18nApi from '@/api/i18nApi.js'
import joinApi from '@/api/joinApi.js'
import memberApi from "@/api/memberApi.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
export default {
	data() {
		return {
			countryList: null,
			phoneNo:null,
			dob: '',
			personalInfo : null,
			responsibilityList: {},
			selectedCountry: null,
			selectedResponsibility: null,
			phoneTextField: null,
			submitState: false,
			validIcon: ''
		}
	},
	created() {
	   
	},
	components: {
		TopAppBarDrawer
	},
	watch: {
		selectedDuty: function(value) {
			//this.fatchResponsibilityData()
		}
	},

	mounted() {
		this.setMaterialUi()
		this.fatchCountryData()
		this.fatchData()
		this.$refs.phoneNo.focus()
	},

   
	computed: {
		phoneInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('phoneNo')) {
					returnValue = true
					this.validIcon = 'report_problem'
				}else {
					returnValue = false
					this.validIcon = 'check'
				}
			}
			this.phoneTextField.valid === !returnValue ? '' : this.phoneTextField.valid = !returnValue
			return returnValue
		},
	},


	methods: {
		// Store 변이 정의(define store mutation)
	   // ...mapMutations('join', ['SET_RESPONSIBILITY', 'SET_DUTY', 'SET_DUTYNAME', 'SET_RESPONSIBILITYNAME']),

		setMaterialUi() {
			const selects = [].map.call(document.querySelectorAll('.mdc-select'), function(el) {
				let select = new MDCSelect.attachTo(el)
				return select
			})
			this.phoneTextField = new MDCTextField(document.querySelector('#emailEl'))
			this.phoneTextField.useNativeValidation = false

			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})

			//this.phoneTextField.value = this.phoneNo
		},

		// get duty data
		fatchCountryData() {
		   let params = {
			brandCode: localStorage.getItem('brandCode')
		  }
		  i18nApi.guestCountryList(params).then((response) => {
			  this.countryList = response.data.data
			  this.selectedCountry = this.countryList[0]
		  }).catch((err) => {
			  console.log(err)
		  })
		},
		
		fatchData() {
			memberApi.getMemberInfo().then((response)=>{
				this.personalInfo = response.data.data
				this.dob = this.personalInfo? this.personalInfo.birth:''
				if(this.personalInfo.phone && this.personalInfo.phone.phone) {
                    this.phoneNo = this.personalInfo.phone.phone;
                }
			})
		},

		// next
		next() {
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
					let params = {
					  phone:{
						country : this.selectedCountry.code,
						phone : this.phoneNo,
					  },
					  birth:this.dob
					}
					memberApi.addPhoneNo(params).then((response) => {
						let responseData = response.data.data
						if (responseData) {
							this.$router.push({
							  name: "MemberDetail",
							})
						} else {
						}
					}).catch((err) => {
					  console.log(err)
					})
					
				} else{
					this.focusFirstInvalidElement()
				}
			})
		},
		isNumber: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode === 46) {
				evt.preventDefault();;
			} else {
				return true;
			}
		},

		cancel() {
			this.$router.push({
				name: "MemberDetail",
			})
		}
	}
}
</script>
<style scoped>
.mdc-select-control-custom{
	border-radius: 4px;
    padding-top: 10px;
}
.invalid-icon-data.mdc-text-field--outlined
.mdc-notched-outline__leading,
.invalid-icon-data.mdc-text-field--outlined
.mdc-notched-outline__notch,
.invalid-icon-data.mdc-text-field--outlined
.mdc-notched-outline__trailing {
border-color:var(--Textfeilderror)!important;
}
.check_show{
	display: block !important;
}
.invalid-icon-data:not(.mdc-text-field--disabled) .mdc-floating-label,
.invalid-icon-data:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing {
    color: #b00020;
    color: var(--mdc-theme-error, #b00020);
}
.valid-icon-data:not(.mdc-text-field--disabled) .mdc-floating-label,
.valid-icon-data:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing {
    color: rgba(0, 0, 0, 0.6);
}
.mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__leading, .mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__notch, .mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__trailing{
	border-color: var(--Textfeildactive) !important;
}
.mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__leading, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__notch, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{
	border-color: var(--Textfeildactive) !important;
}

.mdc-select--outlined.hasActiveVal select  {
	color: var(--HeadlineBlack) !important;
}

.mdc-select--outlined.hasActiveVal select option {
	color: var(--BodygrayA) !important;
}
</style>